const Switch = require('weatherstar-switch');

import '../../../node_modules/bootstrap-colorpicker/dist/js/bootstrap-colorpicker';
import '../../../node_modules/icheck/icheck.js';

/**
 * User interface elements init
 *
 */
export let ui = {

    /**
     * init text editor
     *
     * @param classEl - class elements on which will be init plugin
     */
    editor_init(classEl) {
      if($(classEl).length === 0){
        return;
      }

      $(classEl).each(function (i, el) {
        let idEl = el.id;
        let fileUploadUrl = el.getAttribute('data-upload-url');

        CKEDITOR.replace( idEl, {
          customConfig:'',

          filebrowserUploadUrl: fileUploadUrl,

          stylesSet: false,
          title : false,
          // language: 'en',

          language: app.locale,
          allowedContent: true,
          toolbar : [

            { name: 'document', items : [ 'Source','-','Save','NewPage','DocProps','Preview','Print','-','Templates' ] },
            { name: 'clipboard', items : [ 'Cut','Copy','Paste','PasteText','PasteFromWord','-','Undo','Redo' ] },
            // { name: 'editing', items : [ 'Find','Replace','-','SelectAll','-','SpellChecker', 'Scayt' ] },
            { name: 'forms', items : [ 'Form', 'Checkbox', 'Radio', 'TextField', 'Textarea', 'Select', 'Button', 'ImageButton',
                'HiddenField' ] },
            { name: 'basicstyles', items : [ 'Bold','Italic','Underline','Strike','Subscript','Superscript','-','RemoveFormat' ] },
            { name: 'paragraph', groups: [ 'list', 'indent', 'align', 'bidi' ],
              items: [ 'NumberedList', 'BulletedList', '-', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock' ] },
            { name: 'links', items : [ 'Link','Unlink', ] },
            { name: 'insert', items : [ 'Image','Flash','Table','HorizontalRule','Smiley','SpecialChar','PageBreak','Iframe' ] },
            { name: 'styles', items : [ 'Format','Font','FontSize' ] },
            { name: 'colors', items : [ 'TextColor','BGColor' ] },
            { name: 'tools', items : [ 'Maximize', 'ShowBlocks',] }
          ],
          removeDialogTabs : 'image:advanced;link:upload;link:advanced',
        });
        CKEDITOR.instances[idEl].on('change', function() {
          $('#'+idEl).val(CKEDITOR.instances[idEl].getData());
        });
      });

    },


  /**
     * init plugin iCheck for checkboxes and radio buttons
     */
    iCheckInit() {

        //select only checkboxes and radio buttons with data-icheck attribute
        let inputs = $('input[type="checkbox"][data-icheck], input[type="radio"][data-icheck]');

        $(inputs).each(function (i, el) {

            //if data-icheck attribute isn't empty- takes an input color from it
            if($(el).data('icheck') !== ''){
                let color = $(el).data('icheck');

                $(el).iCheck({
                    checkboxClass: `icheckbox_minimal-${color}`,
                    radioClass   : `iradio_minimal-${color}`
                });
            } else {//if data-icheck attribute is empty - init default style input (black)

                $(el).iCheck({
                    checkboxClass: 'icheckbox_minimal',
                    radioClass   : 'iradio_minimal'
                });
            }
        });
    },


    /**
     * init Switchery plugin for checkboxes
     *
     * @param elements - element on which will be init plugin
     */
    switchery(elements){

        $.each(elements, function(i,el){
            let size = $(el).data('size');
            let color = $(el).data('color');
            let secondaryColor = $(el).data('secondary');
            let jackColor = $(el).data('jack');

            if(!color) color = '#3cb53d';

            new Switch(el,{
                size: size,
                onSwitchColor : color,
                offSwitchColor : secondaryColor,
                onJackColor : jackColor
            });
        })
    },

    /**
     * init Color picker plugin
     *
     * @param el - element on which will be init plugin
     */
    color_picker(el){
        $(el).colorpicker();
    }

    //not used functions (commented 28.04.18)

    // /*Collapse all box in form edit*/
    // box_collapse: function() {
    //     $('.with-collapse').find('.fa-minus').removeClass('fa-minus').addClass('fa-plus');
    //     $('.with-collapse').find('.box').addClass('collapsed-box');
    // },

    /**
     * Init select with dependencies possibility
     */
    // dependent_selects_init: function() {
    //     $('body').on('change', '.js_depend_select', function() {
    //
    //         var depended_select = $($(this).data('depend'));
    //         $(depended_select).html('');
    //
    //         var data_src = $(this).data('src') + '/' + $(this).val();
    //
    //         controls.ajax_action(data_src, 'GET',
    //             function(data) {
    //                 var options = $.parseJSON(data);
    //                 if (options.length > 0) {
    //                     options.forEach(function(item) {
    //                         $(depended_select).prepend('<option value="' + item.id + '">' + item.name + '</option>');
    //                     });
    //                 }
    //             },
    //             function(errors) {
    //                 console.log(errors);
    //             }
    //         )
    //     });
    // },
};


// WEBPACK FOOTER //
// ./js/script/components/ui_components.js